import React from 'react'
import styled, { withTheme } from 'styled-components'
import { colors } from '../../../styles/colors'
import { PenIcon } from '../../Icons/PenIcon'
import WashStationSelectModal from './WashStationSelectModal'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;
  @media (max-width: 567px) {
    padding: 0;
  }
`
const StyledItemWrapper = styled.div`
  //min-width: 230px;
  // margin-top: 5px;
  // flex: 0 0 230px;
  flex: 1 1 calc(40% - 8px);
  @media (max-width: 567px) {
    padding: 0;
    font-size: 0.6rem;
  }
  @media (max-width: 426px) {
    flex: 0;
  }
`
const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  font-size: 15px;
  line-height: 1.4;
  max-width: '460px';
  padding-top: 20px;
  @media (max-width: 426px) {
    flex-direction: column;
  }
  @media (max-width: 567px) {
    gap: 10px;
    padding: 0;
  }
`
const StyledLabel = styled.div`
  text-transform: uppercase;
  font-weight: bold;
`
const StyledValue = styled.div`
  color: ${colors.secondary};
`
const StyledEditIconWrapper = styled.div`
  padding: 4px;
  cursor: pointer;
`
const WashStationData = (props) => {
  const { t, washStore, theme } = props
  const handleCloseWashStationSelectModal = async () => {
    washStore.setShowWashStationSelectModal(false)
  }
  return (
    <>
      <StyledContainer {...props}>
        <StyledWrapper>
          <StyledItemWrapper>
            <div className='d-flex align-items-center'>
              <div>
                <StyledLabel>
                  {t('washPage:station')}
                </StyledLabel>
                <StyledValue className='value-color'>
                  {washStore.washStation?.displayName || t('washPage:stationUnknown')}
                </StyledValue>
              </div>
              <StyledEditIconWrapper
                onClick={() => washStore.setShowWashStationSelectModal(!washStore.showWashStationSelectModal)}
              >
                <PenIcon
                  color={theme.primaryColor}
                  title={t('washPage:changeStation')}
                />
              </StyledEditIconWrapper>
            </div>
          </StyledItemWrapper>
        </StyledWrapper>
      </StyledContainer>
      {washStore.showWashStationSelectModal && (
        <WashStationSelectModal
          handleClose={handleCloseWashStationSelectModal}
        />
      )}
    </>)
}

export default withTheme(withTranslation()(
  inject(
    'washStore',
  )(observer(WashStationData)))
)
